import { render, staticRenderFns } from "./HoldingPage.vue?vue&type=template&id=46e4f0c1&"
import script from "./HoldingPage.vue?vue&type=script&lang=js&"
export * from "./HoldingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports